export enum BatchRecipientResultId {
    EmailProcessProcessed = 1,
    EmailProcessDropped,
    EmailDeliverDelivered,
    EmailDeliverDeferred,
    EmailDeliverBounce,
    EmailReadOpen,
    EmailReadClick,
    EmailReadSpamReport,
    EmailReadUnsubscribe,
    EmailReadGroupUnsubscribe,
    EmailReadGroupResubscribe,
    Sent,
    InQueue,
    UndeliveredErrorAttemptingDelivery = 17, // This resultId should be 17 not 14 according to Postman responses.
    Processing = 15,
    NoSendList = 16,
}

export enum BatchStatusCode {
    Draft = 'draft',
    Pending = 'notsent',
    Sending = 'sending',
    Sent = 'sent',
    Failed = 'notsent:failed',
}

export enum CommunicationTypeId {
    Phone = 1,
    Email = 2,
    Sms = 3,
    Mms = 4,
}
